import React, { useEffect } from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import { selectors as onboardingSelectors } from "reducers/onboarding";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";
import { ResponsiveHeader } from "pages/_components/header";
import { goBack, push } from "connected-react-router";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";

const StepEmailSuccess = ({ isMobile, onboardingWithEnrolledUser }) => {
    const dispatch = useDispatch();

    useEffect(() => {}, [dispatch]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const onContinue = () => {
        dispatch(push("/onboarding/stepSms"));
    };

    return (
        <>
            {isMobile && (
                <ResponsiveHeader
                    ticket
                    id={i18nUtils.getOnboardingHeaderTitleId(onboardingWithEnrolledUser)}
                    onClickBack={isMobile && onHeaderBack}
                />
            )}{" "}
            <MainContainer>
                {!isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}

                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "¡Ya validamos tu email!")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding2.svg" className="svg-image logo" />
                </div>
                {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                <br />
                <div className="box box-border-soft">
                    <CustomText text={i18nUtils.get("", "Ahora vamos a validar tu celular")} />
                </div>

                <div className="form-actions">
                    <Button bsStyle="primary" label="global.continue" loading={false} onClick={onContinue} />
                </div>
            </MainContainer>
        </>
    );
};

StepEmailSuccess.propTypes = {
    isMobile: bool.isRequired,
    onboardingWithEnrolledUser: bool.isRequired,
};

const mapStateToProps = (state) => ({
    onboardingWithEnrolledUser: onboardingSelectors.getOnboardingWithEnrolledUser(state),
});

export default connect(mapStateToProps)(StepEmailSuccess);
